import { createStyles } from 'antd-style';

/** useAdminLayoutStyles 定义由 Host 统一持有的管理台外层布局样式。 */
export const useAdminLayoutStyles = createStyles(({ css, token }) => ({
  layout: css`
    min-height: 100vh;
    background: ${token.colorBgLayout};
  `,
  header: css`
    position: sticky;
    z-index: 100;
    top: 0;
    display: flex;
    height: 64px;
    align-items: center;
    padding: 0 20px 0 0;
    border-block-end: 1px solid ${token.colorBorderSecondary};
    background: ${token.colorBgContainer};
    line-height: normal;
  `,
  brand: css`
    display: flex;
    width: 248px;
    min-width: 248px;
    align-items: center;
    gap: 10px;
    padding: 0 20px;
    border: 0;
    background: transparent;
    cursor: pointer;
    text-decoration: none;
    text-align: start;
  `,
  logo: css`
    width: 38px;
    height: 38px;
    object-fit: contain;
  `,
  brandTitle: css`
    color: ${token.colorText} !important;
    font-size: 18px;
    white-space: nowrap;
  `,
  topNavigation: css`
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    align-self: stretch;
    align-items: center;
    gap: 4px;
    overflow-x: auto;
  `,
  topMenuItem: css`
    display: inline-flex;
    height: 46px;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: ${token.colorTextSecondary};
    cursor: pointer;
    font-size: 15px;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      background: ${token.colorFillTertiary};
      color: ${token.colorText};
    }
  `,
  topMenuItemSelected: css`
    background: ${token.colorPrimaryBg} !important;
    color: ${token.colorPrimary} !important;
  `,
  menuIcon: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
  `,
  productArrow: css`
    font-size: 10px;
    transition: transform ${token.motionDurationMid};
  `,
  productArrowOpen: css`
    font-size: 10px;
    transform: rotate(180deg);
    transition: transform ${token.motionDurationMid};
  `,
  productList: css`
    display: flex;
    width: 160px;
    flex-direction: column;
    gap: 8px;
  `,
  productItem: css`
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 42px;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: ${token.colorTextSecondary};
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      background: ${token.colorFillTertiary};
      color: ${token.colorText};
    }
  `,
  productItemSelected: css`
    background: ${token.colorPrimaryBg};
    color: ${token.colorPrimary};
  `,
  headerActions: css`
    flex: 0 0 auto;
    margin-inline-start: 20px;
  `,
  workspaceButton: css`
    display: inline-flex;
    min-height: ${token.controlHeight}px;
    align-items: center;
    padding: 4px 15px;
    border: 1px solid ${token.colorPrimary};
    color: ${token.colorPrimary};
    border-radius: 18px;
    text-decoration: none;

    &:hover {
      border-color: ${token.colorPrimary} !important;
      background: ${token.colorPrimaryBg} !important;
      color: ${token.colorPrimary} !important;
    }
  `,
  profile: css`
    min-width: 0;
    cursor: pointer;
  `,
  profileText: css`
    min-width: 0;
    max-width: 132px;
  `,
  staffName: css`
    overflow: hidden;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  tenantName: css`
    overflow: hidden;
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  profileArrow: css`
    font-size: 10px;
  `,
  body: css`
    min-height: calc(100vh - 64px);
    background: ${token.colorBgLayout};
  `,
  sider: css`
    position: sticky !important;
    inset-block-start: 64px;
    height: calc(100vh - 64px);
    overflow: visible !important;
    border-inline-end: 1px solid ${token.colorBorderSecondary};
    background: ${token.colorBgContainer} !important;

    .ant-layout-sider-children {
      overflow: visible;
    }
  `,
  siderScroll: css`
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  `,
  siderMenu: css`
    padding: 0 12px 16px;
    border-inline-end: 0 !important;

    .ant-menu-item,
    .ant-menu-submenu-title {
      min-height: 48px;
      margin-block: 2px;
      border-radius: 8px;
      line-height: 48px;
    }

    /* 激活叶子时父分组只负责保持展开，不能和叶子同时出现选中背景。 */
    .ant-menu-submenu-selected > .ant-menu-submenu-title {
      background: transparent !important;
    }
  `,
  menuLabel: css`
    display: inline-flex;
    min-width: 0;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: ${token.marginXS}px;
  `,
  collapseToggle: css`
    position: absolute;
    z-index: 10;
    top: 8px;
    right: 0;
    display: flex;
    width: 28px;
    height: 34px;
    align-items: center;
    justify-content: center;
    padding: 0;
    transform: translateX(50%);
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: 18px;
    background: ${token.colorBgContainer};
    color: ${token.colorText};
    cursor: pointer;
  `,
  collapseIcon: css`
    display: inline-flex;
    transform: rotate(180deg);
    transition: transform ${token.motionDurationMid};
  `,
  collapseIconCollapsed: css`
    display: inline-flex;
    transition: transform ${token.motionDurationMid};
  `,
  content: css`
    display: flex;
    min-width: 0;
    flex-direction: column;
    padding: 24px;
    background: ${token.colorBgLayout};

    /* 列表页的根卡片填满面包屑下方空间，内容超出时仍按自身高度自然撑开。 */
    > .ant-card {
      flex: 1 0 auto;
    }
  `,
  pageHeader: css`
    display: flex;
    min-height: 32px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-block-end: 12px;
  `,
  pageHeaderActions: css`
    display: flex;
    min-width: 0;
    flex: 0 0 auto;
    align-items: center;
    gap: ${token.marginXS}px;
    justify-content: flex-end;
  `,
  breadcrumb: css`
    min-width: 0;
    margin: 0;

    a {
      color: inherit;
      text-decoration: none;
    }
  `,
}));
